export enum InvitationStatus {
  INITIATED = 'INITIATED',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
}
